// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import {
  CompetitorProduct,
  type CompetitorProductWireFormat,
  NewCompetitorProduct,
} from '../CompetitorProduct/CompetitorProduct';

export class QuoteCompetitorProduct {
  readonly id: string;
  readonly price: string | null;
  readonly competitorProduct: CompetitorProduct;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.price = data.price === undefined ? null : data.price;
    this.competitorProduct = NewCompetitorProduct(data.competitorProduct);
  }

  static zero(): QuoteCompetitorProduct {
    const zeroValues: ExcludeMethodsDeep<QuoteCompetitorProduct> = {
      id: NIL_UUID,
      price: null,
      competitorProduct: CompetitorProduct.zero(),
    };
    return new QuoteCompetitorProduct(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteCompetitorProductWireFormat = {
  id: string;
  price: string | null;
  competitorProduct: CompetitorProductWireFormat;
};

type NewQuoteCompetitorProductProps = PartialDeep<
  QuoteCompetitorProduct,
  { recurseIntoArrays: true }
>;
export const NewQuoteCompetitorProduct: (
  props: NewQuoteCompetitorProductProps,
) => QuoteCompetitorProduct = (props) => new QuoteCompetitorProduct(props);

type NewQuoteCompetitorProductFromWireFormatProps = PartialDeep<
  QuoteCompetitorProductWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteCompetitorProductFromWireFormat: (
  props: NewQuoteCompetitorProductFromWireFormatProps,
) => QuoteCompetitorProduct = (props) => new QuoteCompetitorProduct(props);
